import React from 'react';
import { TextField, MenuItem } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import ACTIONS from 'redux-lib/actions/actions';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      width: '25ch',
      paddingTop: 16
    },
  },
  select: {
    '& .MuiSelect-icon': {
      color: '#3f88b1'
    }
  }
}));

function Depreciation(props) {
  const classes = useStyles(); 

  const dispatch = useDispatch();
  const states = useSelector(state => {
    return state.globalStates
  })

  const fmv = states ? states.initial_fmv ? states.initial_fmv : 0 : 0;
  const depreciation = states ? states.depreciation ? states.depreciation : 0 : 0;

  const getCurentFmv = () => {
    let result = fmv;
    if(states && states.manual_fmv && states.is_on_manual_fmv) {
      result = states.manual_fmv; 
    }
    return result;
  }

  const renderOptions = () => {
    const options = ['None',1,2,3,4,5,6,7,8,9,10].map((option, key) => {
      return <MenuItem key={ `depreciation-item-${ key }` } value={option}>
        {
          option === 'None' ? 
          <span>{ option }</span> : <span>{ option }&#37;</span>
        }
      </MenuItem>
    })
    return options;
  }

  const handleChange = (e) => {
    dispatch({
      type: ACTIONS.UPDATE_DEPRECIATION,
      payload: e.target.value
    })
    dispatch({
      type: ACTIONS.UPDATE_FMV,
      payload: getDepractedFMV(e.target.value)
    })
  }

  const getDepractedFMV = (value) => {
    const currentFmv = getCurentFmv();
    let result = parseFloat(value);
    if(value && value !== '') {
      if( value === 'None' ) {
        result = states.initial_fmv;
      } else {
        if(currentFmv && currentFmv !== '' && currentFmv !== 0) {
          result = parseFloat(currentFmv) - ((parseFloat(value) / 100) * parseFloat(currentFmv));
        }
      }
      
    }
    return result;
  }

  return(
    <div className={ classes.root }>
      <TextField
        autoComplete="on"
        id="standard-select-depreciation"
        select
        name="depreciation"
        label="Depreciation"
        value={ depreciation }
        className={ classes.select }
        onChange={handleChange}
        InputLabelProps={{
          shrink: true
        }}
      >
        { renderOptions() }
      </TextField>
    </div>
  )
}

export default Depreciation;